<template>
  <!-- 官网头部组件（仅PC端，选中效果明显） -->
  <header class="website-header">
    <!-- 头部容器 -->
    <div class="header-container">
      <!-- Logo 区域 -->
      <div class="header-logo" >
        <img src="@/assets/axcu.jpg" alt="医疗行为闭环管理平台" width="330" >
        <!-- <span class="logo-text">医疗行为闭环管理平台</span> -->
      </div>

      <!-- 导航栏（仅PC端，选中效果强化） -->
      <nav class="header-nav">
        <router-link to="/" class="nav-item" exact active-class="nav-active">网站首页</router-link>
        <router-link to="/product" class="nav-item" active-class="nav-active">产品中心</router-link>
        <router-link to="/about" class="nav-item" active-class="nav-active">关于我们</router-link>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: 'WebsiteHeader',
  data() {
    return {};
  }
};
</script>

<!-- 注意：这里先移除 scoped，避免样式隔离导致选中效果失效，确保百分百生效 -->
<style>
/* 全局头部样式 */
.website-header {
  width: 100%;
  background-color: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999; /* 保证头部在最上层，不被其他内容遮挡 */
}

/* 头部容器（居中限制宽度） */
.header-container {
  width: 50%;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 80px;
}

/* Logo 区域 */
.header-logo {
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: opacity 0.3s ease; /* Logo 轻微hover效果 */
}

.header-logo:hover {
  opacity: 0.9;
}


.logo-text {
  font-size: 18px;
  font-weight: 600;
  color: #2f4f4f; /* 深灰绿色，适配医疗行业风格 */
}

/* 桌面端导航（核心：强化选中效果，一眼可辨） */
.header-nav {
  display: flex;
  gap: 40px; /* 导航项之间的间距 */
  cursor: pointer;
}

.nav-item {
  text-decoration: none;
  font-size: 16px;
  color: #333333;
  transition: all 0.3s ease; /* 所有变化都添加过渡，效果更顺滑 */
  position: relative; /* 为伪元素（底部下划线）做定位 */
  padding: 8px 16px; /* 扩大点击区域，同时为选中背景预留空间 */
  border-radius: 4px; /* 配合选中背景的圆角 */
}

/* 1. 鼠标hover效果（变色+底部下划线浮现） */
.nav-item:hover {
  color: #1677ff; /* hover 时变为蓝色 */
  background-color: #f0f7ff; /* hover 轻微背景色，提升交互感 */
}

/* 用伪元素实现底部下划线，比直接设置border-bottom更细腻 */
.nav-item::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 16px; /* 对应 nav-item 的左右 padding，让下划线和文字对齐 */
  right: 16px;
  height: 2px; /* 下划线高度 */
  background-color: #1677ff; /* 下划线颜色，和文字颜色一致 */
  transform: scaleX(0); /* 初始缩放为0，隐藏下划线 */
  transition: transform 0.3s ease; /* 缩放过渡，实现渐显效果 */
}

.nav-item:hover::after {
  transform: scaleX(1); /* hover 时缩放为1，显示下划线 */
}

/* 2. 选中激活效果（强烈视觉对比，一眼识别当前页面） */
.nav-active {
  color: #1677ff !important; /* 选中时强制蓝色，确保优先级 */
  font-weight: 600; /* 选中加粗，强化视觉 */
  background-color: #e6f7ff !important; /* 高亮背景块，和导航栏形成强烈对比 */
}

/* 选中状态下，下划线常驻且完整显示 */
.nav-active::after {
  transform: scaleX(1); /* 选中时下划线完全显示 */
}
</style>